import DOMPurify from 'dompurify';
import {InlineAlert} from 'letrus-ui';
import {useState} from 'react';
import getFeatureFlag from 'utils/functions/getFeatureFlags';

const ALERT_FLAG_KEY = 'homepage_student_alert';
const SESSION_STORAGE_KEY = 'hideCustomizableAlert';

interface AlertAttachment {
  text?: string;
  link?: string;
}

function FlagrAlert() {
  const [seenByUser, setSeenByUser] = useState(false);

  const alertFlag = getFeatureFlag(ALERT_FLAG_KEY);
  const attachment = alertFlag?.variantAttachment as
    | AlertAttachment
    | undefined;

  const seenOnSession = sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';

  const hasText = Boolean(attachment?.text?.trim());

  const shouldRender =
    Boolean(alertFlag?.isOn) && hasText && !seenByUser && !seenOnSession;

  if (!shouldRender) {
    return null;
  }

  const link = attachment?.link;
  const hasLink = Boolean(link);

  function handleClose() {
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    setSeenByUser(true);
  }

  return (
    <InlineAlert
      backgroundColor="#E8F2FC"
      mainColor="#2A5082"
      firstButtonText="Fechar"
      // Only offer the "Saiba Mais" button when there is a link to open —
      // the flag text can be customized without providing one.
      secondButtonText={hasLink ? 'Saiba Mais' : undefined}
      leftIcon={{icon: ['fad', 'lightbulb-on']}}
      onClickFirstButton={handleClose}
      onClickSecondButton={
        hasLink
          ? () => window.open(link, '_blank', 'noopener,noreferrer')
          : undefined
      }
    >
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(attachment?.text ?? ''),
        }}
      />
    </InlineAlert>
  );
}

export default FlagrAlert;
